// extracted by mini-css-extract-plugin
export default {"navbar":"navbar_navbar__LGZGB","navbarItem":"navbar_navbarItem__r3YKx","active":"navbar_active__UfSWU"};